import { LS_PREFIX } from "../config";
import { FEATURE_FLAGS } from "../flags";

// Get Feature Flag
export const ff = (key) => {
    // Official launch date/time
    const time = Math.floor((new Date).getTime() / 1000);
    const date = `${(new Date()).getFullYear()}-${`${(new Date()).getMonth() + 1}`.padStart(2, '0')}-${`${(new Date()).getDate()}`.padStart(2, '0')}`;

    // Timestamp based release
    if (typeof FEATURE_FLAGS?.[key]?.announcement === 'number' && time >= FEATURE_FLAGS?.[key]?.announcement) {
        return true;
    }

    // Date based release
    if (typeof FEATURE_FLAGS?.[key]?.announcement === 'string' && date >= FEATURE_FLAGS?.[key]?.announcement) {
        return true;
    }

    if (typeof localStorage === 'undefined') {
        return false;
    }

    return !!localStorage.getItem(`${LS_PREFIX}ff_${key}`);
}

// Set Feature Flag
export const setff = (key, state) => {
    if (state) {
        localStorage.setItem(`${LS_PREFIX}ff_${key}`, 'true');
    } else {
        localStorage.removeItem(`${LS_PREFIX}ff_${key}`);
    }
}
